module.exports = __webpack_public_path__ + "static/media/icon_logo_2.806ffff1.png";